import { render } from "./AdminRegistration.vue?vue&type=template&id=7ca2de76"
import script from "./AdminRegistration.vue?vue&type=script&lang=js"
export * from "./AdminRegistration.vue?vue&type=script&lang=js"

import exportComponent from "/builds/octoblue/narrowcastingrpi/narrowcastingwebapp/narrowcasting_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__